var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-center"},[_c('h4',[_vm._v("\n      Click\n      "),_c('span',{style:({
          'font-weight': 'bold',
          cursor: 'pointer',
          'text-decoration': 'underline'
        }),on:{"click":function () { return _vm.$refs.treatmentQuestionModal.show(); }}},[_vm._v("here")]),_vm._v("\n      to ask a question.\n    ")])]),_vm._v(" "),_c('TreatmentQuestionModal',{ref:"treatmentQuestionModal"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44dea433","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/QA/AskQuestion.vue
// module id = null
// module chunks = 